import { groupErrors } from './ldapPropTypes';

import { PureComponent } from 'react';
import { FieldArray, Form, reduxForm } from 'redux-form/immutable';

import { Button } from 'components/Button/Button';
import FormErrorMessage from 'components/FormErrorMessage';
import LTEBox from 'containers/LTEBox';
import LeaveDialogue from 'containers/LeaveDialogue';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import fetch from 'utils/fetch';
import handleEvent from 'utils/handleEvent';
import RenderRoleAssignments from './RenderRoleAssignments';
import { fetchRoles } from './actions';
import { PAGE_URL } from './constants';

const validate = (values) => {
  const errors = {};
  const roleAssignments = values.get('roleAssignments');
  if (!roleAssignments || !roleAssignments.size) {
    errors.roleAssignments = { _error: 'requiredRole' };
  } else {
    const roleAssignmentsArrayErrors = [];
    roleAssignments.forEach((group, index) => {
      const roleAssignmentsErrors = {};
      if (!group.get('groupName')) {
        roleAssignmentsErrors.groupName = 'required';
      }
      if (Object.keys(roleAssignmentsErrors).length) {
        roleAssignmentsArrayErrors[index] = roleAssignmentsErrors;
      }
    });
    if (roleAssignmentsArrayErrors.length) {
      errors.roleAssignments = roleAssignmentsArrayErrors;
    }
  }
  return errors;
};

@reduxForm({
  enableReinitialize: true,
  validate,
  pure: false,
})
@fetch({ actions: [fetchRoles] })
export default class RoleAssignmentsForm extends PureComponent {
  static propTypes = {
    anyTouched: PropTypes.bool,
    change: PropTypes.func.isRequired,
    configurationId: PropTypes.string.isRequired,
    error: PropTypes.string,
    groupErrors: groupErrors,
    handleSubmit: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    leaveDialogueMessages: PropTypes.object.isRequired,
    msg: PropTypes.object.isRequired,
    onDomainOptionsChange: PropTypes.func.isRequired,
    onClearGroupError: PropTypes.func.isRequired,
    onClearGroupErrors: PropTypes.func.isRequired,
    onSetReturnUrl: PropTypes.func.isRequired,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool.isRequired,
    valid: PropTypes.bool,
  };

  componentWillUnmount() {
    this.props.onClearGroupErrors();
  }

  handleFieldChange = handleEvent(() => {
    const { onDomainOptionsChange } = this.props;
    onDomainOptionsChange({ dataModified: true });
  });

  handleSave = handleEvent(() => {
    const { handleSubmit } = this.props;
    handleSubmit();
  });

  handleCloseEditConfiguration = handleEvent(() => {
    const { navigate } = this.props;
    navigate(PAGE_URL);
  });

  handleLeaveDialogueSave = handleEvent((returnUrl) => {
    const { handleSubmit, onSetReturnUrl } = this.props;
    onSetReturnUrl(returnUrl);
    handleSubmit();
  });

  render() {
    const {
      change,
      configurationId,
      groupErrors,
      handleSubmit,
      leaveDialogueMessages,
      msg,
      onClearGroupError,
      pristine,
      submitting,
      anyTouched,
      error,
      valid,
    } = this.props;
    return (
      <div>
        <LeaveDialogue
          isPristine={pristine}
          isValid={valid && !groupErrors.size}
          msg={leaveDialogueMessages}
          onSave={this.handleLeaveDialogueSave}
        />
        <Form onSubmit={handleSubmit} autoComplete='off'>
          <fieldset className='p-0' disabled={submitting}>
            <LTEBox
              bodyComponent={
                <div>
                  <FieldArray
                    change={change}
                    component={RenderRoleAssignments}
                    configurationId={configurationId}
                    groupErrors={groupErrors}
                    msg={msg}
                    name='roleAssignments'
                    onChange={this.handleFieldChange}
                    onClearGroupError={onClearGroupError}
                  />
                </div>
              }
              className='box box-test-connection'
              title={get(msg, [
                'configurations',
                'roleAssignments',
                'boxTitle',
              ])}
            />
            {anyTouched && error && typeof error === 'string' && (
              <FormErrorMessage>
                {get(msg, ['validation', error], 'Error')}
              </FormErrorMessage>
            )}
            <div className='mt-3'>
              <Button
                type='button'
                variant='primary'
                icon='fa-check'
                onClick={this.handleSave}
                className='mr-2'
              >
                {get(msg, 'btnConfirm')}
              </Button>
              <Button
                variant='secondary'
                type='button'
                onClick={this.handleCloseEditConfiguration}
                icon='fa-xmark'
              >
                {get(msg, 'btnCancel')}
              </Button>
            </div>
          </fieldset>
        </Form>
      </div>
    );
  }
}
